module.exports = __webpack_public_path__ + "img/40_00_084_523.597aa457.jpg";